// @/components/reusable/loading-content.jsx
// V2 Loading Content — inline/contextual loading spinner with message

import React from "react";
import * as motion from "motion/react-client";
import clsx from "clsx";

const sizeConfig = {
  small: { container: "h-16", loader: "loader small", gap: "mb-3" },
  medium: { container: "h-32", loader: "loader", gap: "mb-6" },
  large: { container: "h-48", loader: "loader", gap: "mb-6" },
};

/**
 * LoadingContent — V2 inline loading spinner with optional message.
 * Transparent background by default. Uses the standard .loader CSS animation.
 *
 * @param {string}  message   - Text below the spinner
 * @param {string}  size      - "small" | "medium" | "large"
 * @param {boolean} centered  - Center content (default: true)
 * @param {string}  className - Additional classes on the outer wrapper
 */
const LoadingContent = ({
  message,
  size = "medium",
  centered = true,
  className,
}) => {
  const cfg = sizeConfig[size] || sizeConfig.medium;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={clsx(
        cfg.container,
        "w-full py-6",
        centered && "flex flex-col items-center justify-center",
        className
      )}
    >
      <div className={clsx("relative", cfg.gap)}>
        <div className={cfg.loader}>
          <div className="loader-inner" />
        </div>
      </div>

      {message && (
        <h4 className="font-[400] text-center">{message}</h4>
      )}
    </motion.div>
  );
};

export { LoadingContent };
export default LoadingContent;
